// Components==============
import Container from 'components/UI/Container';
import React, { useContext } from 'react';
import { GlobalContext } from 'utilities/GlobalContextWrapper';
import { useMediaQ } from 'utilities/useMediaQ';
import Logo from './components/Logo';
import MobileMenu from './components/MobileMenu';
import NavButton from './components/NavButton';
import NavItems from './components/NavItems';
import './index.module.scss';

// =========================

export default function Nav() {
    const query = useMediaQ('min', 1024);

    const { isDashboard } = useContext(GlobalContext);

    return (
        <Container>
            <div styleName="grid">
                {!query && (
                    <div styleName="mobileMenu">
                        <MobileMenu />
                    </div>
                )}
                <div styleName="logo">
                    <Logo />
                </div>
                {query && (
                    <>
                        <div
                            styleName={`${
                                isDashboard ? 'dashboard' : ''
                            } navItems`}
                        >
                            <NavItems />
                        </div>
                        {/* <NavButton query={query} /> */}
                    </>
                )}
            </div>
        </Container>
    );
}
